export const dmqEventListener = (event) => {
    console.log("DMQ Message received: ", event);
    switch(event) {
        case "GUEST_CHECK_IN": 
                document.dispatchEvent(window.guestCheckin)
                break;
        case "QUEUED_GUEST_CHECKED_IN":
                document.dispatchEvent(window.queuedGuestCheckedIn)
                break;
        case "DEVICE_REGISTRATION":
                document.dispatchEvent(window.deviceRegistration)
                break;
        case "GUEST_INFO_UPDATE": 
                document.dispatchEvent(window.guestInfoUpdate)
                break;
        case "MESSAGE_PENDING": 
                document.dispatchEvent(window.messagePending)
                break;
        case "DEVICE_DATA_REFRESH": 
                document.dispatchEvent(window.deviceDataRefresh)
                break;
        case "DEVICE_WIPE": 
                document.dispatchEvent(window.deviceWipe)
                break;
        case "GUEST_CHECK_OUT":
                document.dispatchEvent(window.guestCheckout)
                break;
        default: break; 
    }
}

export const registerDmqEvent = (event) => {

    console.log("resistering events")
    window.guestCheckin = new CustomEvent("GUEST_CHECK_IN")
    window.queuedGuestCheckedIn = new CustomEvent("QUEUED_GUEST_CHECKED_IN");
    window.deviceRegistration = new CustomEvent("DEVICE_REGISTRATION")
    window.guestInfoUpdate = new CustomEvent("GUEST_INFO_UPDATE")
    window.messagePending = new CustomEvent("MESSAGE_PENDING")
    window.deviceDataRefresh = new CustomEvent("DEVICE_DATA_REFRESH")
    window.deviceWipe = new CustomEvent("DEVICE_WIPE")
    window.guestCheckout = new CustomEvent("GUEST_CHECK_OUT")
}